export const /** @type {?} */ GroupQuestionTemplates = {
  defaultTemplate: {
    property: {
      display: true,
      disable: false,
      key: '',
      questions: []
    },
    style: {}
  }
}
